import { DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_FAILURE, DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_REQUEST, DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_SUCCESS, WorkedInLast30DaysExcelActionTypes, WorkedInLast30DaysExcelState } from 'store/reducers/types/workedInLast30Days/workedInLast30DaysExcel';

const defaultState: WorkedInLast30DaysExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function workedInLast30DaysExcel(state = defaultState, action: WorkedInLast30DaysExcelActionTypes): WorkedInLast30DaysExcelState {
  switch (action.type) {
    case DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case DOWNLOAD_WORKED_IN_LAST_30_DAYS_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};